import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "status-page-wrapper"
};
export default {
  __name: 'perm-error',
  props: {
    from: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "status-message"
      }, [_createElementVNode("i", {
        class: "vxe-icon-warning-triangle"
      }), _createElementVNode("span", null, "[403]权限不足，不能操作，请联系管理员")], -1)), _createVNode(_component_vxe_button, {
        status: "primary",
        href: __props.from,
        icon: "vxe-icon-back"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("返回", -1)]))]),
        _: 1
      }, 8, ["href"])]);
    };
  }
};